import React, { useState } from 'react';
import api from '../../api/api';

export default function StatusWorkflow({ statuses, onRefresh }) {
  const [searchTerm, setSearchTerm] = useState('');
  const [page, setPage] = useState(1);
  const [editingId, setEditingId] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [isAdding, setIsAdding] = useState(false);
  const [newForm, setNewForm] = useState({
    name: ''
  });

  const filteredStatuses = statuses.filter(status => 
    status.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const itemsPerPage = 10;
  const totalPages = Math.ceil(filteredStatuses.length / itemsPerPage);
  const currentItems = filteredStatuses.slice((page - 1) * itemsPerPage, page * itemsPerPage);

  const handleEdit = (status) => {
    setEditingId(status.id);
    setEditForm({ ...status });
  };

  const handleSave = async () => {
    try {
      await api.put(`/statuses/${editingId}`, {
        name: editForm.name
      });
      setEditingId(null);
      onRefresh();
    } catch (error) {
      alert('Failed to update status');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure?')) return;
    try {
      await api.delete(`/statuses/${id}`);
      onRefresh();
    } catch (error) {
      alert('Failed to delete status');
    }
  };

  const handleAdd = async () => {
    try {
      await api.post('/statuses', {
        name: newForm.name
      });
      setIsAdding(false);
      setNewForm({ name: '' });
      onRefresh();
    } catch (error) {
      alert('Failed to add status');
    }
  };

  return (
    <>
      <div className="admin-card-header">
        <div style={{ display: 'flex', alignItems: 'center', gap: '1.5rem', flex: 1 }}>
          <h3>Status Workflow</h3>
          <div className="search-box" style={{ position: 'relative', flex: 1, maxWidth: '400px' }}>
            <span style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#94a3b8' }}>🔍</span>
            <input 
              type="text" 
              placeholder="Search statuses..." 
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setPage(1);
              }}
              style={{ 
                width: '100%', 
                padding: '0.6rem 1rem 0.6rem 2.5rem', 
                borderRadius: '0.5rem', 
                border: '1px solid #e2e8f0',
                fontSize: '0.9rem'
              }}
            />
          </div>
        </div>
        <button className="btn-primary small-btn" onClick={() => setIsAdding(true)}>+ Add Status</button>
      </div>

      {isAdding && (
        <div style={{ padding: '1.5rem', background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
          <h4>Add New Status</h4>
          <div style={{ display: 'flex', gap: '1rem', marginTop: '1rem', alignItems: 'center' }}>
            <input 
              type="text" 
              placeholder="Status Name" 
              value={newForm.name} 
              onChange={e => setNewForm({...newForm, name: e.target.value})}
              style={{ padding: '0.5rem', borderRadius: '0.4rem', border: '1px solid #cbd5e1', flex: 1, maxWidth: '300px' }}
            />
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <button className="btn-primary small-btn" onClick={handleAdd}>Save</button>
              <button className="btn-secondary small-btn" onClick={() => setIsAdding(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      <div className="admin-table-wrapper">
        <table className="admin-table">
          <thead>
            <tr>
              <th>Status Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {currentItems.map((status) => (
              <tr key={status.id}>
                <td>
                  {editingId === status.id ? (
                    <input 
                      type="text" 
                      value={editForm.name} 
                      onChange={e => setEditForm({...editForm, name: e.target.value})} 
                      style={{ padding: '0.4rem', borderRadius: '0.3rem', border: '1px solid #cbd5e1', width: '100%', maxWidth: '300px' }}
                    />
                  ) : (
                    <strong>{status.name}</strong>
                  )}
                </td>
                <td>
                  <div className="actions-cell">
                    {editingId === status.id ? (
                      <button className="action-btn" onClick={handleSave} title="Save">💾</button>
                    ) : (
                      <button className="action-btn" onClick={() => handleEdit(status)} title="Edit">✏️</button>
                    )}
                    <button className="action-btn" onClick={() => handleDelete(status.id)} title="Delete">🗑️</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {totalPages > 1 && (
        <div className="pagination-container" style={{ padding: '1rem' }}>
          <button className="pagination-btn" disabled={page === 1} onClick={() => setPage(page - 1)}>Prev</button>
          <span>Page {page} of {totalPages}</span>
          <button className="pagination-btn" disabled={page === totalPages} onClick={() => setPage(page + 1)}>Next</button>
        </div>
      )}
    </>
  );
}
